// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__df0Wq","link":"styles_link__3tJcV"};